import { gql } from 'graphql-request'

export const allPharmacies = gql`
  {
    pharmacies {
      id
      name
      phone
      contact_person
      email
      isPriority
      isPotential
      pharmacy_cluster {
        id
        name
      }
      address {
        address_name
        city
        zipcode
        longitude
        latitude
      }
      tasks {
        until
      }
      available_for_callcenter
      parent {
        id
      }
      pharmacy_status
      reason_for_deactivation
      additional_data
    }
  }
`

export const getPharmacy = (...parts: string[]) => gql`
  query getPharmacy($id: ID) {
    pharmacy(id: $id) {
      ${parts.join(',')}
    }
  }
`

export const getPharmacyByPharmacyCluster = gql`
query getPharmacyByPharmacyCluster($pharmacyClusterId: String, $quarterId: ID) {
    pharmacies(pharmacy_cluster_id: $pharmacyClusterId) {
      id
      name
      okid
      classification      
      appointments(quarter_id: $quarterId) {
        id
        appointmentType {
          id
          label
        }
        order_items {
          project_id
          amount
          project {
            name
            is_orderable
          }
        }
      }
      pharmacy_cluster {
        id
        name
      }
      projects {
        id
        name
        pivot {
          status_id
          is_priority
        }
      }
      tasks {
        id
        until
        state
        created_at
      }
      address {
        address_name
        city
        zipcode
        longitude
        latitude
      }
      address {
        longitude
        latitude
      }
      available_for_callcenter
      pharmacy_status
      reason_for_deactivation
    }
  }
`

export const getPharmacyAddresses = gql`
query getPharmacyAddresses($pharmacyClusterId: String) {
    pharmacies(pharmacy_cluster_id: $pharmacyClusterId) {
      id
      name
      okid
      phone
      classification
      pharmacy_cluster {
        id
        name
      }
      address {
        address_name
        city
        zipcode
      }
      tasks {
        id
        until
        state
        created_at
      }
    }
  }
`

export const getPharmacyDetails = gql`
  query getPharmacy($id: ID, $quarterId: ID) {
    pharmacy(id: $id) {
      id
      name
      okid
      phone
      isPriority
      isPotential
      fax
      email
      contact_person
      owner
      url
      computed_state(quarter_id: $quarterId)
      computed_label   
      facebook
      classification
      call {
        user {
          name
        }
        created_at
      }
      finished_presentations {
        id
        device_count
        endtime
        starttime
        time_spent
        number_of_participants
        fr_trainer_id
        project {
          id
          name
        }
      }
      address {
        address_name
        city
        zipcode
        longitude
        latitude
      }
      opening_times
      branches {
        id
        name
        okid
        address {
          address_name
          city
          zipcode
        }
        phone
        email
      }
      pharmacy_cluster {
        name
      }
      projects {
        name
        id
        pivot {
          status_id
          is_priority
        }
        is_orderable
      }
      notes {
        id
        title
        content
        note_type
        created_at
        user {
          name
        }
        created_at
      }
      tasks {
        id
        note
        contact_person
        until
        state
        user {
          id
          name
        }
        created_at
      }
      available_for_callcenter
      employees {
        id
        first_name
        last_name
        email
        is_campus_user
        completed_trainings
        zipcode
        pharmacy {
          id
          okid
        }
      }
      campus_registration_code
      nicorette_flagship_segment
      parent {
        id
        name
        okid
        address {
          address_name
          city
          zipcode
        }
      }
      activity_log {
        user_name
        model
        event
        timestamp
      }
      pharmacy_status
      reason_for_deactivation
      additional_data
      open_ok_request
    }
  }
`

export const getPharmacyEmployees = gql`
  query getPharmacy($id: ID) {
    pharmacy(id: $id) {
      id
      name
      employees {
        id
        first_name
        last_name
        email
        is_campus_user
        completed_trainings
        zipcode
        pharmacy {
          id
          okid
        }
      }
    }
  }
`
export const getPharmacyAppointments = gql`
  query getPharmacy($id: ID) {
    pharmacy(id: $id) {
      id
      name
      okid
      appointments {
        id
        date
        appointmentType {
          id
          label
        }
        status {
          id
          label
        }
        order_items {
          project_id
          amount
          project {
            name
            is_orderable
          }
        }
        sent_confirmation_at
      }
      finished_presentations {
        id
        device_count
        endtime
        starttime
        time_spent
        number_of_participants
        adjusted_number_of_participants
        sent_confirmation_at
        project {
          id
          name
        }
        trainer {
          name
        }
      }
    }
  }
`

export const getPharmacyEmployeePositions = gql`
  {
    employeePositions {
      id
      name
    }
  }
`

export const getPharmacySearchResults = gql`
  query searchPharmacy($search: String) {
    searchPharmacy(search: $search) {
      id
      name
      okid
    }
  }
`

export const getPharmacyCustomerSheet = gql`
  query pharmacyCustomerSheet($id: ID) {
    pharmacy(id: $id) {
      id
      name
      okid
      available_for_callcenter
      pharmacy_status
      campus_registration_code
      contact_person
      owner
      phone
      email
      url
      facebook
      address {
        address_name
        zipcode
        city
      }
      parent {
        id
      }
      notes {
        id
        content
        created_at
      }
      tasks {
        id
        note
        contact_person
        until
        state
        user {
          id
          name
        }
        created_at
      }
      call {
        created_at
        user {
          name
        }
      }
      opening_times
      employees {
        id
        first_name
        last_name
        email
        is_campus_user
        completed_trainings
        zipcode
        pharmacy {
          id
          okid
        }
      }
      branches {
        id
        name
      }
      open_training_appointments {
        id
        date
        appointmentType {
          id
          label
        }
        order_items {
          project_id
          amount
          project {
            name
            is_orderable
          }
        }
        creator {
          id
        }
      }
      open_visit_appointments {
        id
        date
        appointmentType {
          id
          label
        }
        creator {
          id
        }
        order_items {
          project_id
          amount
          project {
            name
            is_orderable
          }
        }
      }
      completed_training_appointments {
        id
        date
        appointmentType {
          id
          label
        }
        creator {
          id
        }
        order_items {
          project_id
          amount
          project {
            name
            is_orderable
          }
        }
      }
      completed_visit_appointments {
        id
        appointmentType {
          id
          label
        }
        creator {
          id
        }
        order_items {
          project_id
          amount
          project {
            name
            is_orderable
          }
        }
      }
    }
  }
`

export const getSamples = gql`
  query GetSamples {
    getSamples {
      id
      name
    }
  }
`

export const getPharmacyInfoHtml = gql`
  query pharmacyInfoHtml($pharmacy_id: ID!) {
    pharmacyInfoHtml(pharmacy_id: $pharmacy_id) {
      html
    }
  }
`

